var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 48,
    viewBox: "0 0 55 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4606 47.56C44.6667 47.56 54.6131 37.6357 54.6131 25.4075C54.6131 13.2015 44.6667 3.255 32.4606 3.255C20.2324 3.255 10.3081 13.2015 10.3081 25.4075C10.3081 37.4285 19.8989 47.223 31.8409 47.5515L32.4606 47.56Z",
    fill: "url(#paint0_linear)",
    style: {
      mixBlendMode: "color-dodge"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.0454 20.537C42.043 20.5325 42.0412 20.528 42.0387 20.5236C42.0376 20.5217 42.0363 20.5201 42.0352 20.5182C41.9049 20.2946 41.7172 20.1097 41.4917 19.9828L33.4819 15.4773C33.2636 15.3555 33.0178 15.2915 32.7679 15.2915C32.5179 15.2915 32.2721 15.3555 32.0539 15.4773L24.0439 19.9829C23.8175 20.1104 23.6294 20.2962 23.499 20.521C23.4976 20.5234 23.4959 20.5257 23.4945 20.5281C23.4923 20.5321 23.4907 20.5362 23.4886 20.5402C23.3663 20.7576 23.3019 21.0027 23.3016 21.2521V30.2307C23.3018 30.4891 23.3707 30.7428 23.5011 30.9658C23.6316 31.1888 23.8189 31.3732 24.044 31.5L32.054 36.0056C32.2558 36.1184 32.4815 36.1815 32.7125 36.1896C32.7291 36.1909 32.7456 36.1924 32.7624 36.1926H32.769C32.7919 36.1926 32.8146 36.1913 32.837 36.1892C33.0633 36.1791 33.2841 36.1162 33.4818 36.0056L41.4917 31.5C41.7168 31.3732 41.9042 31.1889 42.0346 30.9658C42.165 30.7428 42.2339 30.4891 42.2341 30.2307V21.2521C42.2338 21.0015 42.1688 20.7551 42.0454 20.537ZM32.7678 16.7466L40.0262 20.8294L37.2391 22.4128L29.8952 18.3624L32.7678 16.7466ZM32.8507 24.906L25.5206 20.8232L28.4023 19.2022L35.7537 23.2567L32.8507 24.906ZM33.5071 34.3204L33.5787 26.1673L36.5018 24.5067V27.9724C36.5018 28.1655 36.5785 28.3508 36.715 28.4873C36.8516 28.6239 37.0368 28.7006 37.2299 28.7006C37.423 28.7006 37.6083 28.6239 37.7448 28.4873C37.8814 28.3508 37.9581 28.1655 37.9581 27.9724V23.6793L40.7777 22.0775V30.2307L33.5071 34.3204Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b",
    x: -2.71215,
    y: -9.76525,
    width: 70.3456,
    height: 70.3456,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 6.51013
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -32.4995,
    y1: -7.00006,
    x2: 26.5005,
    y2: 116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA4B58",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.90e4ceedc12707eba9bdeab7b93dc8b0.svg";
export { ForwardRef as ReactComponent };